/*
	Inspired by https://github.com/cbrandolino/camvas but modified to suit the needs of our project
*/

const mediaCapabilities = { video: true, audio: false };

const getUserMedia = async capabilities =>
  navigator.mediaDevices.getUserMedia(capabilities);

const createHiddenVideoElement = () => {
  const streamContainer = document.createElement("div");
  const video = document.createElement("video");

  // If we don't do this, the stream will not be played.
  video.setAttribute("autoplay", "1");
  video.setAttribute("playsinline", "1");

  // The video should fill out all of the canvas
  video.setAttribute("width", 1);
  video.setAttribute("height", 1);

  streamContainer.appendChild(video);
  document.body.appendChild(streamContainer);

  return video;
};

export default async (ctx, callback) => {
  const video = createHiddenVideoElement();
  let raf;
  // As soon as we can draw a new frame on the canvas, we call the `draw` function
  // we passed as a parameter.
  const update = () => {
    let last = Date.now();
    const loop = () => {
      // For some effects, you might want to know how much time is passed
      // since the last frame; that's why we pass along a Delta time `dt`
      // variable (expressed in milliseconds)
      const dt = Date.now() - last;
      callback(video, dt);
      last = Date.now();
      raf = requestAnimationFrame(loop);
    };
    loop();
  };

  const stop = () => {
    video.pause();
    video.srcObject = null;
    cancelAnimationFrame(raf);
  };

  const start = async () => {
    const stream = await getUserMedia(mediaCapabilities);
    video.srcObject = stream;
    update();
  };

  await start();
  return stop;
};



// WEBPACK FOOTER //
// ./src/components/Webcam/vendor/camvas.js